import React from 'react'

const NotFound = () => {
  return (
    <div>
      <h1 className="display-4"><span className="text-danger">404 Page Not Found</span></h1>
      <p className="lead">Sorry, that page does not exist</p>
    </div>
  )
}

export default NotFound
